// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gn-player_row{height:8vh;width:100%;display:flex;flex-wrap:nowrap}.gn-player_row .gn-player_row-block{flex:1 1 130px}.gn-player_row .gn-player_row-block-interactive{flex:1 1 130px}.gn-player_row .gn-player_row-block-interactive:hover{cursor:pointer}@media screen and (max-width: 720px){.gn-player_row{height:4.25vh}}", ""]);
// Exports
module.exports = exports;
